import React from "react";
import { Row, Col } from "reactstrap";
import { AccordionComponent } from "../../../../CommonElements/Accordion";
import PermissionCheckbox from "../components/PermissionCheckbox";

export const renderPermissionsForDisplay = ({
  nodes,
  selectedPermissions,
  level = 0,
  col = 6, // Default to col-md-6
  t, // Add t function as parameter
}) => {
  return nodes
    .map((node,ix) => {
      const hasPermissions = node.permissions && node.permissions.length > 0;
      const hasChildren = node.children && node.children.length > 0;

      // Get all permission IDs from this node and its children (for display state)
      const getAllPermissionIds = (node) => {
        let ids = new Set();
        if (node.permissions) {
          node.permissions.forEach((perm) => ids.add(perm?.id));
        }
        if (node.children) {
          node.children.forEach((child) => {
            const childIds = getAllPermissionIds(child);
            childIds.forEach((id) => ids.add(id));
          });
        }
        return ids;
      };

      const allPermissionIds = getAllPermissionIds(node);
      const allSelected = Array.from(allPermissionIds).every((id) =>
        selectedPermissions.has(id)
      );
      const anySelected = Array.from(allPermissionIds).some((id) =>
        selectedPermissions.has(id)
      );

      // Create content for this node
      let content = null;

      // If node has its own permissions, show them
      if (hasPermissions) {
        const permissionsContent = (
          <div className="mb-3">
            {node.permissions.map((permission) => (
              <PermissionCheckbox
                key={permission?.id}
                permission={permission}
                isSelected={selectedPermissions.has(permission?.id)}
                onChange={() => {}} // No-op for display
                mode="display"
                className="d-flex align-items-center gap-2 mb-2"
              />
            ))}
          </div>
        );

        if (hasChildren) {
          // Node has both permissions and children
          content = (
            <div>
              {permissionsContent}
              <div className="mt-3">
                <AccordionComponent
                  className="nested-accordion"
                  items={renderPermissionsForDisplay({
                    nodes: node.children,
                    selectedPermissions,
                    level: level + 1,
                    col,
                    t, // Pass t function to recursive calls
                  })}
                />
              </div>
            </div>
          );
        } else {
          // Node has only permissions, no children
          content = permissionsContent;
        }
      } else if (hasChildren) {
        // Node has only children, no permissions
        content = (
          <AccordionComponent
            className="nested-accordion"
            items={renderPermissionsForDisplay({
              nodes: node.children,
              selectedPermissions,
              level: level + 1,
              col,
              t, // Pass t function to recursive calls
            })}
          />
        );
      } else {
        // Node has neither permissions nor children - show empty state
        content = (
          <div className="text-muted p-3">
            <small>{t("NO_PERMISSIONS_IN_SECTION")}</small>
          </div>
        );
      }

      // Always return an accordion item (unless content is null)
      if (content) {
        return {
          id: node?.id.toString(),
          title: node.name_ar,
          className: level === 0 ? `col-md-${col}` : "w-100",
          content,
          showCheckbox: false,
        };
      }

      return null;
    })
    .filter(Boolean);
};
